<div *ngIf="infosCoordenador as infos">
  <div class="row">
    <div class="w-100">
      <app-card [titulo]="infos.nomeCoordenador">
        <div text>
          <div class="d-flex flex-column">
            <bdg-info-label
              *ngIf="infos.cpf"
              direction="horizontal"
              label="CPF"
              labelType="body-1"
              labelStyle="fontWeight: 700"
            >
              {{ infos.cpf | cpf | infoLabel }}
            </bdg-info-label>

            <bdg-info-label
              *ngIf="infos.email"
              direction="horizontal"
              label="E-mail"
              labelType="body-1"
              labelStyle="fontWeight: 700"
            >
              {{ infos.email | infoLabel }}
            </bdg-info-label>

            <div class="d-flex justify-content-between">
              <bdg-info-label direction="horizontal" label="Telefone" labelType="body-1" labelStyle="fontWeight: 700">
                {{ infos.telefone | telefone | infoLabel }}
              </bdg-info-label>
              <bdg-button
                *ngIf="hasButton"
                label="Alterar"
                (click)="onAlterarClicked()"
                style="position: absolute; left: 80%; top: 60%"
              ></bdg-button>
            </div>
          </div>
        </div>
      </app-card>
    </div>
  </div>
</div>
